import { createUseStyles } from 'react-jss'

const styles = {
	page: {
		minHeight: '100vh',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}

export default createUseStyles(styles)
